import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "shortcut-filter-bar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.shortcutFilterButtons && $props.shortcutFilterButtons.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.shortcutFilterButtons, (button, index) => {
                return (_openBlock(), _createBlock($setup["EnShortcutFilterButton"], {
                    key: button.key || index.toString(),
                    id: button.key || index.toString(),
                    label: button.label,
                    state: $setup.getButtonState(button),
                    "filter-callback": button,
                    tooltip: button.tooltip,
                    hint: button.hint,
                    "total-count": $props.totalCount
                }, null, 8 /* PROPS */, ["id", "label", "state", "filter-callback", "tooltip", "hint", "total-count"]));
            }), 128 /* KEYED_FRAGMENT */))
        ]))
        : _createCommentVNode("v-if", true);
}
